module.exports = require("crypto");